<script lang="ts">
	import type { LoadResult } from '@kestrel/server';
	import type { load } from './DetailviewTeaserServer.ts';
	import { mount, onMount } from 'svelte';
	import { logger } from '../../../logger.ts';
	import ToLogin from '../../../components/teaser/small/ToLogin.svelte';
	import { getShowUpLogo, TeaserTouchPoint } from '../../../domain/teaser/TeaserUtils.ts';
	import type VariationChangedEvent from '../../../domain/VariationChangedEvent.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import ToSignUp from '../../../components/teaser/small/ToSignUp.svelte';
	import {
		addElementToDetailviewContextStore,
		detailviewTeaserContextStore
	} from '../../../store/DetailviewTeaserContextStore.ts';

	let { data }: { data: LoadResult<typeof load> } = $props();
	const teaserSize = 'MediaObject25';

	function mapFetchResponse(response: any) {
		return {
			teaserType: response.teaserType,
			teaserContent: response.teaserContent,
			showUpLogo: getShowUpLogo(response.teaserType, TeaserTouchPoint.DETAILVIEW),
			enableSignupSheetMigration: response.enableSignupSheetMigration
		};
	}
	async function fetchContext(variationId: string) {
		let url = `/up-teaserui/gateway/articleTeaserContext?variationId=${variationId}`;

		const cachedContextResponse = $detailviewTeaserContextStore.get(url);
		if(cachedContextResponse){
			logger.info('Response from cache for detailViewContext with teaserType: ' + cachedContextResponse.teaserType);
			return mapFetchResponse(cachedContextResponse);
		}

		try {
			let response = await fetch(url, {
				credentials: 'include',
				method: 'GET',
				headers: { 'Content-Type': 'application/json' }
			});
			if (response.status === 200) {
				return response.json().then(response => {
					logger.info('Response status 200 from articleTeaserContext with teaserType: ' + response.teaserType);

					addElementToDetailviewContextStore(url, response);

					return mapFetchResponse(response);
				});
			} else {
				logger.error(`Status ${response.status} updating detailview teaser context`);
				return undefined;
			}
		} catch (error) {
			logger.error('Error updating detailview teaser context: ' + error);
			return undefined;
		}
	}

	const handleVariationChangedEvent = async (event: VariationChangedEvent) => {
		logger.info(`Handling variation changed event with variation ${event.variationId}`);
		if (event.cdc) {
			event.targetElement.innerHTML = event.variationId;
		} else {
			const response = await fetchContext(event.variationId);

			if (!response || !event.targetElement || response.teaserType === TeaserType.NO_CONTENT) {
				return;
			}

			if (response.teaserType === TeaserType.TO_LOGIN) {
				mount(ToLogin, {
					target: event.targetElement,
					props: {
						teaserContent: response.teaserContent,
						teaserTouchPoint: TeaserTouchPoint.DETAILVIEW,
						showUpLogo: response.showUpLogo,
						teaserSize: teaserSize
					}
				});
			} else {
				mount(ToSignUp, {
					target: event.targetElement,
					props: {
						teaserContent: response.teaserContent,
						teaserType: response.teaserType,
						enableSignupSheetMigration: response.enableSignupSheetMigration,
						teaserSize: teaserSize,
						teaserTouchPoint: TeaserTouchPoint.DETAILVIEW,
						showUpLogo: response.showUpLogo
					}
				});
			}
		}
	};

	onMount(() => {
		if (!data.disableArticleTeaser) {
			window.o_global.eventQBus.on('ft9.up-teaser.variationChanged', handleVariationChangedEvent);
			window.o_global.eventQBus.emit('ft9bcn.teaserui.teaser.isReady', {});
		}
	});
</script>
